// Partículas de ligação que nunca entram no nome curto (só no nome completo, via
// `capitalizeFullName`). "d'" NÃO é partícula: "d'Ávila" é sobrenome (decisão 61).
const NAME_PARTICLES = new Set(['de', 'da', 'do', 'das', 'dos', 'e'])

const LOCALE = 'pt-BR'

// Prefixo de tratamento descartado do nome curto: Dr/Dra/Dr(a), com ou sem ponto.
const DOCTOR_PREFIX = /^dr(a|\(a\))?\.?$/i

// Title Case pt-BR de uma palavra; "d'ávila"/"d’ávila" vira "d'Ávila" (d' minúsculo).
function titleWord(word: string): string {
  const lower = word.toLocaleLowerCase(LOCALE)
  const elision = /^d['’]/.exec(lower)
  if (elision && lower.length > 2) {
    return elision[0] + lower.charAt(2).toLocaleUpperCase(LOCALE) + lower.slice(3)
  }
  return lower.charAt(0).toLocaleUpperCase(LOCALE) + lower.slice(1)
}

/**
 * Nome curto do médico: primeiro + segundo nome, pulando partículas
 * (de/da/do/das/dos/e) e em Title Case pt-BR.
 *
 * "JOÃO DA SILVA FILHO" → "João Silva"; "RAFAEL D'ÁVILA COSTA" → "Rafael d'Ávila".
 *
 * O prefixo "Dr."/"Dra."/"Dr(a)." (com ou sem ponto, qualquer caixa) é descartado
 * ("Dr. Wagner Tavares" → "Wagner Tavares"). A primeira palavra do nome (após o
 * prefixo) nunca é descartada, mesmo que coincida com uma partícula.
 */
export function getFirstAndSecondName(fullName: string): string {
  if (!fullName) return ''

  const allWords = fullName.trim().split(/\s+/).filter(Boolean)
  const nameWords =
    allWords.length > 1 && DOCTOR_PREFIX.test(allWords[0]) ? allWords.slice(1) : allWords

  const words = nameWords.filter(
    (word, index) => index === 0 || !NAME_PARTICLES.has(word.toLocaleLowerCase(LOCALE))
  )

  return words.slice(0, 2).map(titleWord).join(' ')
}
